import { render, staticRenderFns } from "./InvScLPrice.vue?vue&type=template&id=6b09918c"
import script from "./InvScLPrice.vue?vue&type=script&lang=js"
export * from "./InvScLPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports